export const getNotifications = state => state.get('notifications').toJS();

export const isFetching = state => state.get('isFetching');

export const activePassenger = state => state.get('activePassenger');

export const activeStep = state => state.get('activeStep');



// WEBPACK FOOTER //
// ./src/redux/selectors/GlobalSelectors.js